module.exports = __webpack_public_path__ + "static/img/BN.f85e243f.png";